class AuthRolePermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'auth_role.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'auth_role._m';

    // Can access disabled roles
    static ACCESS_DISABLED = 'auth_role.access.disabled';

    // Can access sensitive roles
    static ACCESS_SENSITIVE = 'auth_role.access.sensitive';

    // Can access archive
    static ACCESS_ARCHIVE = 'auth_role.access.archive';

    // Can access roles without permissions
    static ACCESS_EMPTY = 'auth_role.access.empty';

    // Can create new roles
    static CREATE = 'auth_role.create';

    // Can update role
    static UPDATE = 'auth_role.update';

    // Can enable/disable role
    static ENABLE_STATE_MANAGE = 'auth_role.enable_state.manage';

    // Can archive role
    static ARCHIVE = 'auth_role.archive';

    // Can restore role
    static RESTORE = 'auth_role.restore';
}

export default AuthRolePermission;
